import React from 'react';
import moment from 'moment';
import { UncontrolledTooltip } from "reactstrap";
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';



class VideosPrograms extends React.Component {
    constructor(props) {
        super(props);

        this.renderizaIconeHabilitar = this.renderizaIconeHabilitar.bind(this);
        this.obterUsuarioAcao = this.obterUsuario.bind(this);
        this.obterDataModificacao = this.obterDataModificacao.bind(this);

    }
    renderizaIconeHabilitar(item) {
        const {
            idVideoPrograma, habilitado, loading,
        } = item;
        const _publicado = habilitado,
            _functionBtn = _publicado ? "desabilitar" : "habilitar",
            _classIcon = _publicado ? `far fa-eye-slash` : `far fa-eye`,
            _textTooltip = _publicado ? "desabilitar programa" : "habilitar programa";
        return (
            <div className="row no-gutters">
                <div className="col-12 icones" id={`Tooltip-${idVideoPrograma}`}>
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                    ) : (
                        <button onClick={() => this.props.confirmaStatusPublicacao(item, _functionBtn)}>
                            <i className={`${_classIcon}`}></i>
                        </button>
                    )}
                    <UncontrolledTooltip placement="top" target={`Tooltip-${idVideoPrograma}`}>
                        {_textTooltip}
                    </UncontrolledTooltip>
                </div>
            </div>
        )
    }

    obterUsuario(item) {

        const _lengthHist = item.usuarioAcao ? item.usuarioAcao.length : 0,
            _temHist = _lengthHist > 0,
            _nome = _temHist ? item.usuarioAcao[_lengthHist - 1].nome : undefined;
        return (_nome ? <span>{_nome}</span> : <span>sem histórico</span>)
    }

    obterDataModificacao(item) {
        const _lengthHist = item.usuarioAcao ? item.usuarioAcao.length : 0,
            _temHist = _lengthHist > 0,
            _dtAlt = _temHist ? item.usuarioAcao[_lengthHist - 1].data : undefined;
        return (_dtAlt ? <span>{moment(_dtAlt).format("DD/MM/YY")}</span> : <span>sem histórico</span>)
    }
    render() {
        const {
            idVideoPrograma, imagem, nome, dtCriacao, dtUltimoEpsodio, habilitado,
        } = this.props.item;

        const { permissaoEdicaoVideo } = this.props;

        return (
            <div className="row lista-programas">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-2 pointer d-none d-lg-block" onClick={() => this.props.selecionaPrograma(idVideoPrograma)}>
                                    <ImagemFukyo
                                        className={`img-capa-programa img img-fluid`}
                                        src={imagem}
                                        alt={'imagem de capa do programa'} />
                                </div>
                                <div className="col-12 col-lg-10">
                                    <div className="row">
                                        <div className="col-12 col-lg-12">
                                            <div className="row py-1">
                                                <div className="col-12  text-center col-lg-6 text-lg-left pointer" onClick={() => this.props.selecionaPrograma(idVideoPrograma)}>
                                                    <p className="m-0 text-truncate"><strong>Nome: </strong>{nome}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row align-items-center pt-2">
                                        <div className="col-6 d-lg-none pr-0 pointer" onClick={() => this.props.selecionaPrograma(idVideoPrograma)}>
                                            <ImagemFukyo
                                                className={`img-capa-programa img img-fluid`}
                                                src={imagem}
                                                alt={'imagem de capa do programa'} />
                                        </div>
                                        <div className="col-6  text-center col-lg-2  text-lg-left">
                                            <strong><p className="m-0">Dt. criação</p></strong>
                                            <span>{moment(dtCriacao).format("DD/MM/YY")}</span>
                                        </div>
                                        <div className="col-6 text-center col-lg-2 text-lg-left d-none d-lg-block">
                                            <strong><p className="m-0">Dt. último ep.</p></strong>
                                            <span>{moment(dtUltimoEpsodio).format("DD/MM/YY")}</span>
                                        </div>
                                        <div className="col-6  text-center col-lg-2  text-lg-left d-none d-lg-block">
                                            <strong><p className="m-0">Dt. modif. </p></strong>
                                            {this.obterDataModificacao(this.props.item)}
                                        </div>
                                        <div className="col-6  text-center col-lg-3  text-lg-left d-none d-lg-block text-truncate">
                                            <strong><p className="m-0">Usuário</p></strong>
                                            <span>{this.obterUsuario(this.props.item)}</span>
                                        </div>
                                        <div className="col-12  text-center pt-3 pt-lg-0 col-lg-2  text-lg-left">
                                            <strong><p className="m-0">Status</p></strong>
                                            <span className={`badge badge-${habilitado ?
                                                'success' : 'secondary badge-opacity'}`}>{habilitado ? "Habilitado" : "Não habilitado"}</span>
                                        </div>
                                        {permissaoEdicaoVideo && (
                                            <div className="col-6 text-center col-lg-1  text-lg-left d-none d-lg-block">
                                                {this.renderizaIconeHabilitar(this.props.item)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }


}


export default VideosPrograms;